import { useContext, useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import { ThemesContext } from '@/shared/ThemesContext/ThemesContext';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';

export default function useAvaialbleLiveTasks() {
  const themesContext = useContext(ThemesContext);
  const globalContext = useContext(GlobalContext);

  const { state, actions } = useCustomHook({
    defaultState: {
      themes: [],
      activities: [],
    },
    actions: {},
  });

  useEffect(() => {
    if (themesContext.state.loaded) {
      actions.setState({ themes: themesContext.state.themes, loading: false });
    }
  }, [themesContext.state.loaded]);

  useEffect(() => {
    if (state.themes.length) {
      const activities = [];
      for (const theme of state.themes) {
        if (theme.language == globalContext.state.selectedLanguage) {
          for (const activity of theme.activities) {
            if (activity.type == 'realTime') {
              activities.push({
                ...activity,
                theme,
              });
            }
          }
        }
      }
      actions.setState({
        activities,
      });
    }
  }, [state.themes, globalContext.state.selectedLanguage]);

  return { state, actions };
}
